/**
 * 🔌 09-28 agent wave: the agent's watch link highlights its own seat.
 *
 * A connected agent gets `watch_url = …/game-step?gameId=<id>&with=<player_id>`
 * (`with` = the SEAT id its join returned). The person the agent hands that
 * link to opens the room with that seat and its lines picked out in cyan,
 * plus a one-time toast. Pure helpers only; GameStepPage does the wiring.
 *
 * The id lands inside a CSS attribute selector, so the gate is strict: an
 * exact uuid (anchored, case-folded) or null. Anything else, including a
 * selector breakout like `"]{}body{display:none`, is treated as absent.
 */

export const WITH_PARAM = 'with';

const SEAT_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The `with` seat id from a search string (`?gameId=…&with=…`), lowercased, or null. */
export const readWithSeatId = (search) => {
  if (!search || typeof search !== 'string') return null;
  let raw = '';
  try {
    raw = new URLSearchParams(search.startsWith('?') ? search : `?${search}`).get(WITH_PARAM) || '';
  } catch (e) {
    return null;
  }
  raw = raw.trim();
  return SEAT_UUID_RE.test(raw) ? raw.toLowerCase() : null;
};

/** The highlight rules for one seat: its message bubbles + its roster chips. '' for no seat. */
export const withHighlightCss = (seatId) => {
  if (!seatId || !SEAT_UUID_RE.test(seatId)) return '';
  const id = seatId.toLowerCase();
  return `[data-seat="${id}"]{border-left:3px solid #22d3ee!important;box-shadow:0 0 0 1px rgba(34,211,238,.28),0 0 14px -4px rgba(34,211,238,.5)!important}`
    + `[data-seat-chip="${id}"]{outline:2px solid #22d3ee;outline-offset:1px}`;
};

/** The one-time toast line (they/them for agents). */
export const withToastText = (name) => `🤖 ${name} is here. Their lines are highlighted.`;
